import { render, staticRenderFns } from "./ltv-table.vue?vue&type=template&id=c44c502a&"
import script from "./ltv-table.vue?vue&type=script&lang=js&"
export * from "./ltv-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports